import {
  CreatePriorAuthorizationDocumentFormatEnum,
  PriorAuthorizationControllerApi,
} from "../../../../services";
import {
  getConfigObject,
  useMutationWithLoading,
} from "../../../../utils/utils";

type Authorization = {
  authorizationNumber: string;
  payers: Array<string>;
  patientId: string;
  startDate: string;
  endDate: string;
  allowedVisit: number;
  warningCount: number;
  remainingVisit: number;
  notes?: string;
  documentFormat?: CreatePriorAuthorizationDocumentFormatEnum;
  cptCodes?: Array<string>;
  providerId?: string;
  encounterId?: string;
  fileName?: string;
  requestingProviderId?: string;
  attachments?: File;
};

type AuthorizationUpdateParams = {
  authorization: Authorization;
  xTENANTID?: string;
};

/**
 * @author Rajkumar Rathod
 */
export const useAuthorizationCreate = () =>
  useMutationWithLoading((params: AuthorizationUpdateParams) =>
    new PriorAuthorizationControllerApi(
      getConfigObject()
    ).createPriorAuthorization(
      params?.authorization?.authorizationNumber,
      params?.authorization?.payers,
      params?.authorization?.patientId,
      params?.authorization?.startDate,
      params?.authorization?.endDate,
      params?.authorization?.allowedVisit,
      params?.authorization?.warningCount,
      params?.authorization?.remainingVisit,
      undefined, // dateOfRequest
      undefined, // dateOfApproval
      undefined, // dateOfExpiration
      undefined, // serviceType
      undefined, // authorizationStatus — derived by the backend from endDate
      params?.authorization?.notes,
      params?.authorization?.documentFormat,
      undefined, // icdCodes
      params?.authorization?.cptCodes,
      params?.authorization?.providerId,
      params?.authorization?.encounterId,
      params?.authorization?.fileName,
      undefined, // noOfUnit
      undefined, // placeOfService
      params?.authorization?.requestingProviderId,
      params?.xTENANTID,
      params?.authorization?.attachments
    )
  );
